import Vue from "vue";

export default {
  verifyChannel: function(channel) {
    let channels = Vue.prototype.$channels;
    return channels.includes(channel) ? channel : "official";
  },
};
